var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddDistrictIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9083 16.8C12.8906 16.8 12.8751 16.7968 12.8618 16.7914C12.8489 16.7862 12.8349 16.7778 12.8202 16.7631L12.4695 17.1138L12.8202 16.7631C12.7987 16.7416 12.7854 16.7109 12.7854 16.675C12.7854 16.6392 12.7987 16.6084 12.8202 16.5869L12.4739 16.2406L12.8202 16.5869L16.9952 12.4119L16.6489 12.0656L16.9952 12.4119C17.0167 12.3904 17.0475 12.3771 17.0833 12.3771C17.1192 12.3771 17.1499 12.3904 17.1714 12.4119L17.525 12.0583L17.1714 12.4119C17.193 12.4334 17.2062 12.4642 17.2062 12.5C17.2062 12.5359 17.193 12.5666 17.1714 12.5881L13.0042 16.7554C12.9632 16.7917 12.9258 16.8 12.9083 16.8Z",
    fill: "#98A2B3",
    stroke: "#98A2B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0833 12.6167H2.91663C2.88648 12.6167 2.8552 12.6044 2.82955 12.5787C2.80391 12.5531 2.79163 12.5218 2.79163 12.4917C2.79163 12.4615 2.80391 12.4302 2.82955 12.4046C2.8552 12.379 2.88648 12.3667 2.91663 12.3667H17.0833C17.1134 12.3667 17.1447 12.379 17.1704 12.4046C17.196 12.4302 17.2083 12.4615 17.2083 12.4917C17.2083 12.5218 17.196 12.5531 17.1704 12.5787C17.1447 12.6044 17.1134 12.6167 17.0833 12.6167Z",
    fill: "#98A2B3",
    stroke: "#98A2B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91662 7.63334C2.89894 7.63334 2.88341 7.63012 2.87009 7.62475C2.85723 7.61957 2.84319 7.61113 2.8285 7.59645L2.4786 7.94636L2.8285 7.59645C2.80698 7.57492 2.7937 7.54419 2.7937 7.50833C2.7937 7.47248 2.80698 7.44175 2.8285 7.42022L2.48661 7.07832L2.8285 7.42022L7.0035 3.24522C7.02503 3.22369 7.05577 3.21042 7.09162 3.21042C7.12747 3.21042 7.1582 3.22369 7.17973 3.24522C7.20126 3.26675 7.21453 3.29748 7.21453 3.33334C7.21453 3.36919 7.20126 3.39992 7.17973 3.42145L3.00473 7.59645C2.98325 7.61793 2.94436 7.63334 2.91662 7.63334Z",
    fill: "#98A2B3",
    stroke: "#98A2B3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0833 8.13333H2.91663C2.57496 8.13333 2.29163 7.85 2.29163 7.50833C2.29163 7.16666 2.57496 6.88333 2.91663 6.88333H17.0833C17.425 6.88333 17.7083 7.16666 17.7083 7.50833C17.7083 7.85 17.425 8.13333 17.0833 8.13333Z",
    fill: "#98A2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDistrictIcon);
export default __webpack_public_path__ + "1574d33f42f6b74d533813bdbb31069f.svg";
export { ForwardRef as ReactComponent };